import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import { useRoute } from '@nuxtjs/composition-api'
import { renderMarkdown } from '~/functions/markdown'
import {
  netTurnoverNotionId,
  activityTurnoverNotionId,
  capexNotionId,
  activityCapexNotionId,
  opexNotionId,
  activityOpexNotionId,
} from '~/functions/eu-taxonomy'
import type { MetricAssignmentType } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'financial',
  setup(__props) {

const reportingYears = [2024, 2025]
const reportingYearPeriods = reportingYears.map((year) => year.toString())
const route = useRoute()

const variables = computed(() => ({
  assigneeIds: [route.params.venture],
  metricNotionIds: [
    netTurnoverNotionId,
    activityTurnoverNotionId,
    capexNotionId,
    activityCapexNotionId,
    opexNotionId,
    activityOpexNotionId,
  ],
}))

const data = ref<MetricAssignmentType[]>([])

function dataLoaded(assignments: MetricAssignmentType[]) {
  data.value = assignments
}

const euTaxonomyMetricAssignments = computed(() =>
  data.value?.map((e) => ({
    ...e,
    metricValueForReportingYear: e.metricValues.find(
      (value) => reportingYearPeriods.includes(value.period),
    ),
  })) ?? [],
)

const isNetTurnoverSmallerThanSum = computed(() => {
  const netTurnover =
    euTaxonomyMetricAssignments.value.find(
      (e: any) => e.metric?.notionId === netTurnoverNotionId,
    )?.metricValueForReportingYear?.actual ?? 0
  const activityTurnovers = euTaxonomyMetricAssignments.value
    .filter(
      (e: any) => e.metric?.notionId === activityTurnoverNotionId,
    )
    .map((e) => e.metricValueForReportingYear?.actual ?? 0)
  let difference = netTurnover
  activityTurnovers.forEach((value: number) => {
    difference = difference - value
  })
  return difference < 0
})

const isCapexSmallerThanSum = computed(() => {
  const netCapex =
    euTaxonomyMetricAssignments.value.find(
      (e: any) => e.metric?.notionId === capexNotionId,
    )?.metricValueForReportingYear?.actual ?? 0
  const activityCapexes = euTaxonomyMetricAssignments.value
    .filter((e: any) => e.metric?.notionId === activityCapexNotionId)
    .map((e) => e.metricValueForReportingYear?.actual ?? 0)
  let difference = netCapex
  activityCapexes.forEach((value: number) => {
    difference = difference - value
  })
  return difference < 0
})

const isOpexSmallerThanSum = computed(() => {
  const netOpex =
    euTaxonomyMetricAssignments.value.find(
      (e: any) => e.metric?.notionId === opexNotionId,
    )?.metricValueForReportingYear?.actual ?? 0
  const activityOpexs = euTaxonomyMetricAssignments.value
    .filter((e: any) => e.metric?.notionId === activityOpexNotionId)
    .map((e) => e.metricValueForReportingYear?.actual ?? 0)
  let difference = netOpex
  activityOpexs.forEach((value: number) => {
    difference = difference - value
  })
  return difference < 0
})

return { __sfc: true,reportingYears, reportingYearPeriods, route, variables, data, dataLoaded, euTaxonomyMetricAssignments, isNetTurnoverSmallerThanSum, isCapexSmallerThanSum, isOpexSmallerThanSum, renderMarkdown }
}

})